import { render } from "./PageAddSource.vue?vue&type=template&id=22d0a571"
import script from "./PageAddSource.vue?vue&type=script&lang=js"
export * from "./PageAddSource.vue?vue&type=script&lang=js"

import "./PageAddSource.vue?vue&type=style&index=0&id=22d0a571&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.10.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__